var HtGridFilter = function($el, options) {
    var self = this;

    this.form = $el;

    this._defaults = {
        'grid': null //obiekt grida
    };

    this._options = $.extend(true, {}, this._defaults, options);

    this.options = function (options) {
        return (options) ? $.extend(true, this._options, options) : this._options;
    };

    this.reset = function(){

        $(this).find('.filter-row').removeClass('active');

        this.form.find('.filter-value').each(function(){

            if($(this).closest('.multiselect').length > 0 || $(this).closest('.ajax-select').length > 0){

                $(this).val('');
                $(this).trigger('change');

            }else{
                $(this).val('');
                $(this).removeClass('error');
            }

        });

    };

    this.serialize = function() {

        var DELIMITER = "~";
        var SUBDELIMITER = "";

        var filters = [];

        this.form.find('.filter-row').removeClass('active');

        //serializacja pól daty
        this.form.find('.date-range').each(function(){

            var name = $(this).data('field-name');

            if($(this).find('.last').css('display') != 'none'){

                //tylko niepuste pole
                if( $(this).find('.last .number').val() != '' ){

                    var filterValue = name + DELIMITER;
                    filterValue += "last" + $(this).find('.unit').val() + DELIMITER;
                    filterValue +=  $(this).find('.last .number').val();
                    filters.push(filterValue);

                    $(this).addClass('active');
                }

                return;
            }

            if($(this).find('.dates').css('display') != 'none'){
                //zakresdat

                if( $(this).find('.dates .from').val() != '' ){

                    var filterValue = name + DELIMITER;
                    filterValue += "GTE" + DELIMITER;
                    filterValue +=  $(this).find('.dates .from').val();
                    filters.push(filterValue);

                    $(this).addClass('active');
                }

                if( $(this).find('.dates .to').val() != '' ){

                    var filterValue = name + DELIMITER;
                    filterValue += "LTE" + DELIMITER;
                    filterValue +=  $(this).find('.dates .to').val();
                    filters.push(filterValue);

                    $(this).addClass('active');
                }
            }
        });

        this.form.find('.ajax-select').each(function(){

            var name = $(this).data('field-name');

            var o = $(this).find('input[type=hidden]').first();

            if(o.val() != ''){

                var filterValue = name + DELIMITER;
                filterValue += "EQ" + DELIMITER;
                filterValue += o.val();

                filters.push(filterValue);

                $(this).addClass('active');
            }

        });

        this.form.find('.suggest-select').each(function(){

            var name = $(this).data('field-name');

            var o = $(this).find('select.values');
            var d = $(o).select2('data');

            if(d.length > 0){

                var filterValue = name + DELIMITER;
                filterValue += "EQ" + DELIMITER;
                filterValue += d[0].id;

                filters.push(filterValue);

                $(this).addClass('active');
            }

        });



        //serializacja multiselect
        this.form.find('.multiselect').each(function(){

            var name = $(this).data('field-name');

            var o = $(this).find('select.values');
            var d = $(o).select2('data');

            if(d.length > 0){

                var values = "";
                $.each(d, function(key, value){
                    values += value.id + ",";
                });

                values = values.substring(0, values.length - 1);

                var filterValue = name + DELIMITER;
                filterValue += "IN" + DELIMITER;
                filterValue +=  values;

                filters.push(filterValue);

                $(this).addClass('active');
            }

        });


        //pola select
        this.form.find('.select').each(function(){

            var name = $(this).data('field-name');
            var val = $(this).find('.filter-value').val();

            if( null != val && '' != val ){

                var filterValue = name + DELIMITER;
                filterValue += "EQ" + DELIMITER;
                filterValue +=  val;

                filters.push(filterValue);

                $(this).addClass('active');
            }

        });

        //serializacja oznaczen kolorow
        this.form.find('.color-marker-like').each(function(){

            var name = $(this).data('field-name');

            var d = $(this).find('input:checked');

            if(d.length > 0){

                var values = "";

                d.each(function(){
                    values += $(this).val() + ",";
                });


                values = values.substring(0, values.length - 1);

                var filterValue = name + DELIMITER;
                filterValue += "IN" + DELIMITER;
                filterValue +=  values;

                filters.push(filterValue);

                $(this).addClass('active');
            }

        });


        this.form.find('.bigdecimal-range').each(function(){

            var name = $(this).data('field-name');

            if( $(this).find('.from').val() != '' ){

                var filterValue = name + DELIMITER;
                filterValue += "GTE" + DELIMITER;
                filterValue +=  $(this).find('.from').val();

                filters.push(filterValue);

                $(this).addClass('active');
            }

            if( $(this).find('.to').val() != '' ){

                var filterValue = name + DELIMITER;
                filterValue += "LTE" + DELIMITER;
                filterValue +=  $(this).find('.to').val();

                filters.push(filterValue);

                $(this).addClass('active');
            }
        });

        this.form.find('.integer-range').each(function(){

            var name = $(this).data('field-name');

            if( $(this).find('.from').val() != '' ){

                var filterValue = name + DELIMITER;
                filterValue += "GTE" + DELIMITER;
                filterValue +=  $(this).find('.from').val();

                filters.push(filterValue);

                $(this).addClass('active');
            }

            if( $(this).find('.to').val() != '' ){

                var filterValue = name + DELIMITER;
                filterValue += "LTE" + DELIMITER;
                filterValue +=  $(this).find('.to').val();

                filters.push(filterValue);

                $(this).addClass('active');
            }
        });

        //pola wyszukiwania tekstowego
        this.form.find('.text-like').each(function(){

            var name = $(this).data('field-name');

            if( $(this).find('.filter-value').val() != '' ){

                var filterValue = name + DELIMITER;
                filterValue += "LIKE" + DELIMITER;
                filterValue +=  $(this).find('.filter-value').val();

                filters.push(filterValue);

                $(this).addClass('active');
            }

        });

        //pola ukryte - ustawiane przez quick-filter
        this.form.find('.hidden-select').each(function(){

            var name = $(this).data('field-name');

            var values = "";
            $(this).find('input').each(function(k, v){
                values += $(v).val() + ",";
            });
            values = values.substring(0, values.length - 1);

            if(values != "") {
                var filterValue = name + DELIMITER;
                filterValue += "IN" + DELIMITER;
                filterValue += values;

                filters.push(filterValue);

                $(this).addClass('active');
            }

        });

        console.log(filters);

        return filters.map(function callback(currentValue, index, array) {
            return encodeURIComponent(currentValue);
        });

    };

    this.changeSubmitStauts = function(){

        if( this.form.find('input.error').length > 0 ){

            console.log(this);

            this.form.find('button[type=submit]').attr('disabled', 'disabled');
        }else{
            this.form.find('button[type=submit]').removeAttr('disabled');
        }

    };


    this.submitFilter = function(){

        var filters = this.serialize();

        // var gridId = $(this).data('ht.htFilter').settings.gridId;
        //
        // $('#' + gridId).htGrid('filter', filters);

        var grid = this._options['grid'];

        grid.filter(filters);

    };


    this.init = function(){

        //setting events for date-ranges
        this.form.find('.date-range').each(function(){
            var element = $(this);

            if(!element.data('default-last')) {
                $(this).find('.last').hide();
            }else{
                $(this).find('.dates').hide();
            }

            $(this).find('.show-dates').click(function(){
                element.find('.last').hide();
                element.find('.dates').show();
            });

            $(this).find('.show-last').click(function(){
                element.find('.last').show();
                element.find('.dates').hide();
            });
        });

        this.form.find('.multiselect').each(function(){
            // $(this).find('.values').select2({
            //     width: '100%'
            // });
        });

        this.form.find('.suggest-select').each(function(){

            var queryUrl = $(this).data('query-url');

            var v = $(this).find('.values');

            v.select2({
                placeholder: "Wyszukaj...",
                minimumInputLength: 3,
                allowClear: true,
                width: '100%',
                ajax: {
                    url: queryUrl,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term
                        };
                    },

                    processResults: function (data, params) {
                        return {
                            results: data.response.items
                        };
                    },

                    cache: true
                },

                templateResult: function(item){
                    return item.itemMarkup;
                },
                templateSelection: function(item){

                    console.log("SELECTION TEMPLATE", item);

                    return item.selectedMurkup;
                },

                escapeMarkup: function (m) { return m; }

            });


            var isUnselecting = false;

            v.on("select2:unselect", function(e){
                isUnselecting = true;
            });

            v.on('select2:opening', function(e) {
                if (isUnselecting) {
                    e.preventDefault();
                    isUnselecting = false;
                }
            });

        });

        this.form.find('.select').each(function(){
            //$(this).find('.values').select2();
        });

        this.reset();

        //zapisanie formularza
        this.form.submit( function(e){
            e.preventDefault();

            self.submitFilter();

            return false;
        });

        this.form.find('.clear-filter').click(function (e) {
            e.preventDefault();

            self.reset();
            self.submitFilter();

            return false;
        });


        var validate = function(){

            if($(this).val() == '' ){
                $(this).removeClass("error");

                self.changeSubmitStauts();
                return;
            }

            var regexp = $(this).data('regexp-validator');

            if(regexp){
                var match = $(this).val().match(new RegExp(regexp, "g"));

                if(match){
                    $(this).removeClass("error");
                }else{
                    $(this).addClass("error");
                }
            }

            self.changeSubmitStauts();
        };

        //wstepna walidacja pól
        this.form.find('input').keyup(validate);
        this.form.find('input').change(validate);

        var grid = this._options['grid'];

        var block = grid.grid;

    };

    this.init();
};

// @ts-ignore
export function jsGrid($el, options, rowClickCallback, actionCallback, ctrlClick, setupSelectableCallback, contentReloadedCallback) {

    function LoggerCh(name){
        this.name = name;

        this.log = function(){

            var args = Array.prototype.slice.call(arguments);

            args.unshift(this.name);
            args.unshift("font-weight: 800; background-color: #efefef");
            args.unshift("%c[%s]");

            console.log.apply(window, args);

        }

        this.warn = function(){

            var args = Array.prototype.slice.call(arguments);

            args.unshift(this.name);
            args.unshift("font-weight: 800; background-color: #efefef");
            args.unshift("%c[%s]");

            console.warn.apply(window, args);

        }

    }

    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    var LOG = new LoggerCh("Grid");

    var SCROLL_CORRECT = 17;

    var self = this;

    this.grid = $el;

    this.scrollLeftPosition = 0;

    this.itemClickCallback = null;

    this.rowClickCallback = rowClickCallback;

    this.ctrlClickCallback = ctrlClick;

    this.contentReloadedCallback = contentReloadedCallback;


    this.highlightSelectedCallback = setupSelectableCallback;

    this.isTableGrid = true;

    this.quickSearch = null;

    this.lockCount = 0;

    this.infiniteLoading = false;

    if (0 == this.grid.find('.grid-header-container .grid-header-wrapper > table').length) {
        this.isTableGrid = false;
    }

    this.selected = new Array;

    this._defaults = {
        selectable: true,
        selectSingle: false,
        selectCheckboxClass: this.grid.attr('id') + '-id-select',
        columnReorder: false,
        scrollCorrect: 0
    };

    this._options = $.extend(true, {}, this._defaults, options);

    this.options = function (options) {
        return (options) ? $.extend(true, this._options, options) : this._options;
    };

    this.actionCallback = actionCallback;

    this.setActionCallback = function (callback) {
        this.actionCallback = callback;
    };

    this.id = function () {
        return this.grid.attr('id');
    };

    this._bind = function () {

        if (0 == this.grid.find('.grid-header-container .grid-header-wrapper > table').length) {
            this.isTableGrid = false;
        } else {
            this.isTableGrid = true;
        }

        this.loader = this.grid.find('.grid-loader');
        this.paginator = this.grid.find('.grid-paginator');

        this.quickSearch = this.grid.find('.quick-search');

        this.innerContainer = this.grid.find('.grid-inner-container');

        this.gridData = this.grid.find('.grid-data');

        this.gridHeaderContainer = this.grid.find('.grid-header-container');
        this.gridHeaderWrapper = this.grid.find('.grid-header-container .grid-header-wrapper');

        this.gridBodyContainer = this.grid.find('.grid-body-container');
        this.gridBodyWrapper = this.grid.find('.grid-body-container .grid-body-wrapper');

        this.grid.find('.grid-view-sort a').each(function () {
            $(this).click(self.clickLink);
        });

        this.grid.find('.toggle').click(function () {
            if (self.gridFilter.length > 0) {
                self.gridFilter.toggleClass('active');
            }
        });

    };

    this._bind();

    this.lockedBodyContainer = null;
    this.lockedHeaderTable = null;

    this._utilCloneTable = function(source, lockCount, clazz){

        var table = $('<table class="' + clazz + '" style="width:1px;"></table>');
        var colgroup = $('<colgroup></colgroup>');

        var cols = source.find('colgroup col');

        for(var i=0; i<lockCount; i++){
            var colClone = $(cols[i]).clone(true);
            colgroup.append(colClone);
        }

        table.append(colgroup);

        var parts = source.find('> *');

        for(var p=0; p < parts.length; p++){
            var part = $(parts[p]);

            if(part.prop('tagName').toLowerCase() == 'colgroup'){
                continue;
            }

            var tbody = $('<' + part.prop('tagName') +'/>');

            var rows = part.find('tr');

            var rowsSkipps = [];

            for(var i = 0; i < rows.length; i++){
                var r = new Array(lockCount);
                r.fill(0, 0, lockCount);
                rowsSkipps[i] = r;
            }

            for(var i = 0; i < rows.length; i++){

                var colnum = 0;
                for(j = 0; j < lockCount; j++){
                    //skipujemy i nie podnosimy colnum
                    if(rowsSkipps[i][j] == 1){
                        continue;
                    }
                    colnum++;
                    if(rows[i].childElementCount > colnum) {
                        var td = rows[i].children.item(colnum);

                        if(td.hasAttribute('rowspan')){
                            let rowspan = parseInt(td.getAttribute('rowspan'))

                            for(let x=1; x<rowspan; x++){
                                rowsSkipps[i+x][j] = 1;
                            }
                        }
                    }
                }

            }


            for(var i=0; i < rows.length; i++){

                var rh = $(rows[i]).outerHeight();

                var cloneRow = $(rows[i].cloneNode(false));

                cloneRow.css('height', rh);

                var cells = $(rows[i]).find('td, th');

                var sum = 0;
                let colpos = 0;
                for(var j=0; j < lockCount; j++){
                    if(sum >= lockCount){
                        break;
                    }

                    //skipujemy i nie ponosimy sum
                    if(rowsSkipps[i][j] == 1){
                        continue;
                    }

                    cloneRow.append(
                        cells[colpos].cloneNode(true)
                    );

                    colpos++;
                    sum++;

                    if(cells[colpos].hasAttribute('colspan')){
                        sum += parseInt(cells[j].getAttribute('colspan'))-1;
                    }
                }

                tbody.append(cloneRow);
            }

            table.append(tbody);

        }

        return table;
    };

    this.grid.on('change', '.lock-input', function (e) {
        self.lockCount = parseInt($(this).val());
        if(self.lockCount < 0){
            self.lockCount = 0;
            $(this).val(0);
            return;
        }
        self._lockColumns();
    });

    this._updateLock = function(){
        if(self.lockCount === 0){
            return;
        }

        self.grid.find('.lock-input').val(this.lockCount);

        self._lockColumns();
    };

    this._lockColumns = function(){

        if(null != this.lockedBodyContainer){
            this.lockedBodyContainer.remove();
        }

        if(null != this.lockedHeaderTable){
            this.lockedHeaderTable.remove();
        }

        if(this.lockCount === 0){
            return;
        }

        var tbl = this.gridBodyWrapper.find('table');

        if(tbl.length == 0){
            return;
        }

        //jesli mamy niezaladowane obrazki, to lock zrobimy dopiero po ich pobraniu
        var images = tbl.find('img');
        if(images.length > 0){
            var promises = images.map(function (i, img){
                console.log(img);
                if(img.complete){
                    return null;
                }
                return new Promise(function (resolve){
                    img.onload = function () {
                        resolve();
                    }
                })
            }).filter(function (promise) {
                return promise != null;
            });

            if(promises.length > 0) {
                Promise.all(promises).then(function (data) {
                    self._lockColumns();
                });

                return;
            }
        }


        var clone = self._utilCloneTable(tbl, this.lockCount, 'table-body');

        clone.find('td.editor').removeClass('editor');
        clone.find('td .editable').remove();
        clone.find('td .editable-text').show();

        var content = $('<div class="grid-locked-columns"></div>');
        content.append(clone);

        this.lockedBodyContainer = content;

        this.gridBodyContainer.prepend(content);

        content.scrollTop(self.gridBodyWrapper.scrollTop());

        console.log("SSSSSSSSSSSSSSSSSSSSSSSSSSS", self.gridBodyWrapper.scrollTop());

        var headerTable = this.gridHeaderWrapper.find('table');

        this.lockedHeaderTable = self._utilCloneTable(headerTable, this.lockCount, '');

        this.lockedHeaderTable.css({
            'width': null
        });

        //fixing colgroup in locked table
        if(this.lockedHeaderTable.find('.groups-row').length > 0){

            this.lockedHeaderTable.find('.groups-row th').remove();

            var i = 0;
            var offset = 0;

            var prevGroup = null;
            var prevSpan = 1;

            var $groups = this.lockedHeaderTable.find('.groups-row');

            this.lockedHeaderTable.find('.columns-row th').each(function () {

                var $th = $(this);
                var width = $th.outerWidth();

                var group = $th.data('group');

                if (group) {

                    if (null != prevGroup) {

                        if (prevGroup.text() == group) {
                            prevSpan++;
                            prevGroup.attr('colspan', prevSpan);
                        } else {
                            prevSpan = 1;
                            var g = $('<th>' + group + '</th>');
                            $groups.append(g);
                            prevGroup = g;
                        }

                    } else {
                        prevSpan = 1;
                        var g = $('<th>' + group + '</th>');
                        $groups.append(g);
                        prevGroup = g;
                    }

                } else {
                    prevSpan = 1;
                    prevGroup = null;
                    $groups.append('<th class="empty"></th>');
                }

                offset += width;
                i++;
            });

        }

        this.lockedHeaderTable.addClass('locked-header-table');

        this.gridHeaderContainer.prepend(this.lockedHeaderTable);

    };

    this.itemClick = function (callback) {
        this.itemClickCallback = callback;
    };


    this.grid.on('click', '.tree-expand', function (e) {

        LOG.log('Clicked expand', self.gridBodyWrapper);

        var $this = $(this);

        var path = $this.closest('tr').data('path') + "/";

        if($this.hasClass('opened')){
            self.gridBodyWrapper.find('tr[data-path^="' + path + '"]').hide();

            self.gridBodyWrapper.find('tr[data-path^="' + path + '"] .tree-expand').addClass('opened');

            $this.removeClass('opened');
        }else{
            self.gridBodyWrapper.find('tr[data-path^="' + path + '"]').show();
            $this.addClass('opened');
        }
    });

    this.itemLoading = false;

    this.disableMouseClickOnItem = false;

    this.grid.on('mouseup', '.item', function (e) {

        if(self.disableMouseClickOnItem){
            return;
        }

        console.log('MOUSE UP', this, e.target, e);

        if(e.originalEvent && e.originalEvent.which > 1){
            return;
        }

        if ($(e.target).is('input') || $(e.target).is('a')
            || $(e.target).parents('label').length > 0
            || $(e.target).parents('a').length > 0
            || $(e.target).parents('.editor').length > 0
        ) {
            console.log('exit');
            return;
        }

        if(self.headerDragging){
            console.log("exit header dragging");
            return;
        }

        e.preventDefault();

        if(self.itemLoading){
            return;
        }

        if(e.ctrlKey && self.ctrlClickCallback){
            self.ctrlClickCallback(e);
            return;
        }

        console.log('set loading');

        self.itemLoading = true;

        LOG.log("item click");

        LOG.log("GRID", e.target);

        var itemAction = $(this).data('item-action');
        var itemTarget = $(this).data('item-target');

        if(!itemTarget){
            itemTarget = "#main";
        }



        LOG.log("action", itemAction);

        if (self._options['allowNewTab'] ) {

            if (e.ctrlKey || e.which == 2) {

                LOG.log('WITH CTRL CKILC');
                window.getSelection().removeAllRanges();

                var a = $('<a>')
                    .attr('style', 'display: none;')
                    .attr('href', itemAction)
                    .attr('target', '_blank')[0];

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                self.itemLoading = false;
                return;
            }
        }

        if (itemAction) {

            LOG.log("item click", itemAction);


            //TODO: rewrite

            self.rowClickCallback(this, itemAction, itemTarget, e);

            /*
            htc.initComponent(this, 'openDialog', {'bindClick': false, 'url': itemAction, 'target': itemTarget});
            LOG.log(this.ext);

            if(this.ext.comp('openDialog')['onClose']
                && {}.toString.call(this.ext.comp('openDialog')['onClose']) === '[object Function]'
            ){
                this.ext.comp('openDialog').onClose(function(){
                    self.refresh();
                });
            }

            this.ext.comp('openDialog').execute();
            */


            self.itemLoading = false;
        }

        if (self.itemClickCallback) {
            self.itemClickCallback.call(this, e, self);
        }

    });


    this.grid.on('click', '.grid-settings-save', function(e){

        var cols = new Array;

        self.grid.find('.grid-settings-columns input[type=checkbox]').each(function(){
            var $t = $(this);
            cols.push(
                {'name': $(this).attr('name'), 'visible': $(this).is(':checked') }
            );
        });

        var pageLength = self.grid.find('.grid-settings-page-size select').val();

        var settings = {
            'columns': cols,
            'pageLength': parseInt(pageLength)
        };

        self.startLoading();

        $.ajax({
            url: '/save-settings/' + self.id() + "-grid-settings",
            method: 'POST',
            data: JSON.stringify(settings),
            contentType: 'application/json; charset=utf-8'
        }).done(function (e) {
            LOG.log("GRID SETTINGS SAVEWD", e);

            self.refresh();
        });

        LOG.log(settings);

    });

    this.grid.on('click', '.grid-settings-clear', function(e){

        self.startLoading();

        $.ajax({
            url: '/save-settings/_remove',
            method: 'POST',
            data: JSON.stringify([
                self.id() + "-grid-settings",
                self.id() + "-grid-columns"
            ]),
            contentType: 'application/json; charset=utf-8'
        }).done(function (e) {
            LOG.log("GRID SETTINGS SAVEWD", e);

            self.refresh();
        });


    });

    this.grid.on('click', '.grid-action', function (e) {
        e.preventDefault();

        var $btn = this;

        if (self.actionCallback) {
            self.actionCallback(this, self, self.selected, e);
        } else {

            var button = $(this);

            LOG.log("Default grid action", this, self, self.selected, button.attr('href'));

            var d = {
                "ids": self.selected
            };

            $.ajax({
                method: 'POST',
                url: button.attr('href'),
                data: d
            }).done(function (r, a, b) {

                if (button.data('clearSelected')) {
                    LOG.log("clear selected after action");
                    self.clearSelected();
                }

                if(button.data('refresh')){
                    LOG.log("refresh after action");
                    self.refresh();
                }


                //TODO: rewrite
                /**
                htc.initComponent($btn, 'openDialog', {'url': '', 'target': ''});

                var btn = button[0];

                if(btn.ext.comp('openDialog')['onClose']
                    && {}.toString.call(btn.ext.comp('openDialog')['onClose']) === '[object Function]'
                ){
                    btn.ext.comp('openDialog').onClose(function(){
                        self.refresh();
                    });
                }

                //$log.log('ZZZZ', r, 'action resp');

                btn.ext.comp('openDialog')._openHtml(r.response, '#main');
                **/

            });


        }

    });


    this.clearSelected = function () {
        this.selected = new Array;
        this.highlightSelected();
    };

    this._removeSelected = function (s) {

        var i = this.selected.indexOf(s);
        if (i != -1) {
            this.selected.splice(i, 1);
        }

    };

    this.selectedChangeCallback = null;

    this.setSelectedChangeCallback = function(c){
        this.selectedChangeCallback = c;
    };

    this.highlightSelected = function () {


        if(this.highlightSelectedCallback){
            this.highlightSelectedCallback();
        }

        LOG.log('highlightSelected');

        var settings = this._options;

        var allSelected = true;

        this.grid.find('.item').each(function () {

            var v = $(this).find('input.' + settings.selectCheckboxClass).val();

            if (v == '_all') {
                return;
            }

            if ($.inArray(v, self.selected) !== -1) {
                LOG.log(this);
                $(this).addClass('selected');
                $(this).find('input.' + settings.selectCheckboxClass).prop('checked', true);
            } else {
                allSelected = false;
                $(this).removeClass('selected');
                $(this).find('input.' + settings.selectCheckboxClass).prop('checked', false);
            }

        });

        if (allSelected && self.selected.length > 0) {
            LOG.log(this.grid.find('input.' + self._options.selectCheckboxClass + '[value=_all]'));
            this.grid.find('input.' + self._options.selectCheckboxClass + '[value=_all]').prop('checked', true);
        }

        if(self.selected.length > 0) {
            self.grid.find('.selected-counter').html(
                "(" + self.selected.length + ")"
            );
        }else{
            self.grid.find('.selected-counter').html(
                ""
            );
        }

        if (self.selected.length > 0) {
            self.grid.find('.selected-actions').removeClass('disabled');
        } else {
            self.grid.find('.selected-actions').addClass('disabled');
        }

        if(null != this.selectedChangeCallback){
            this.selectedChangeCallback(this.selected);
        }

    };

    this._setupQuickSearch = function(){

        if(this.quickSearch.length == 0){
            return;
        }

        self.grid.find('.clear-quick-search').on('click', function(){
            self.quickSearch.val('');
            self.quickSearch.removeClass('active');

            if(null != self.htGridFilterComponent){
                self.htGridFilterComponent.submitFilter();
            }else{
                self.filter([]);
            }



        });

        this.quickSearch.on('keyup', function(e){

            var code = e.which; // recommended to use e.which, it's normalized across browsers

            if(code === 13){
                e.preventDefault();
                LOG.log("ENTER ON QS");

                if(self.htGridFilterComponent){
                    var filters = self.htGridFilterComponent.serialize();
                    self.filter(filters);
                }else{
                    self.filter([]);
                }

            }

        });

    };



    this._setupSelectable = function () {

        if (this._options.selectable && this._options.selectSingle) {

            console.log("SELECTABLE");

            //disable all select
            this.grid.find('table th input[type="checkbox"]').attr('disabled', 'disabled');

            //select only single element
            this.grid.on('change', 'input.' + this._options.selectCheckboxClass, function () {

                self.grid.find('input.' + self._options.selectCheckboxClass + '[value!=' + $(this).val() + ']').removeAttr('checked');

                if ($(this).is(':checked')) {
                    self.selected = new Array(1);
                    self.selected[0] = $(this).val();
                } else {
                    self.selected = new Array();
                }

                LOG.log(self.selected);

                self.highlightSelected();

            });

        } else if (this._options.selectable) {

            LOG.log('grid: selectable ' + this.grid + ' ' + 'input.' + this._options.selectCheckboxClass);

            this.grid.find('input.' + this._options.selectCheckboxClass).prop('checked', false);

            this.grid.on({

                change: function (e) {

                    LOG.log('change');

                    if ($(this).val() == '_all') {

                        if ($(this).is(':checked')) {

                            //select all checkboxes
                            self.grid.find('input.' + self._options.selectCheckboxClass).prop('checked', true);

                            self.grid.find('input.' + self._options.selectCheckboxClass + '[value!=_all]').each(function () {

                                if ($.inArray($(this).val(), self.selected) === -1) {
                                    self.selected.push($(this).val());
                                }

                            });

                        } else {
                            //deselect all
                            self.grid.find('input.' + self._options.selectCheckboxClass).prop('checked', false);

                            self.grid.find('input.' + self._options.selectCheckboxClass + '[value!=_all]').each(function () {
                                self._removeSelected($(this).val());
                            });

                        }

                    } else {

                        if ($(this).is(':checked')) {
                            self.selected.push($(this).val());
                        } else {
                            self._removeSelected($(this).val());
                            self.grid.find('input.' + self._options.selectCheckboxClass + '[value=_all]').prop('checked', false);
                        }

                    }

                    LOG.log(self.selected);

                    self.highlightSelected();


                }
            }, 'input.' + this._options.selectCheckboxClass);

        }
    };

    this._saveGridSettings = function () {

        var settings = new Array;

        this.gridHeaderWrapper.find('col:not(.scroll-correct)').each(function () {

            if ($(this).data('localguid')) {
                settings.push({
                    'name': $(this).data('localguid'),
                    'width': parseInt($(this).css('width'))
                });
            }

        });

        $.ajax({
            url: '/save-settings/' + this.id() + "-grid-columns",
            method: 'POST',
            data: JSON.stringify(settings),
            contentType: 'application/json; charset=utf-8'
        }).done(function (e) {
            LOG.log("GRID SETTINGS SAVEWD", e);
        });

        LOG.log(settings);
    };

    this._setupBodySize = function () {
        LOG.log("_setupBodySize H x W: ", this.grid.height(), this.grid.width());

        if(this.grid.height() == 0){
            var thg = this;
            setTimeout(function (){
                thg._setupBodySize();
            }, 50);
            return;
        }

        if (this.isTableGrid) {
            LOG.log("IS TABLE")
        }

        if(this._options['static']){
            return;
        }

        //ustawienie wysokości

        var self = this;
        var dataPosition = this.gridData.position();
        var bodyRemain = this.grid.height() - (dataPosition.top );

        if(this.gridHeaderContainer.length > 0) {

            LOG.log("IS TABLE grh");

            bodyRemain -= this.gridHeaderContainer.outerHeight();
        }

        LOG.log(this.gridHeaderContainer, this.gridBodyContainer, bodyRemain);

        this.gridBodyContainer.css('height', bodyRemain + "px");

        if (this.isTableGrid) {

            this.gridBodyWrapper.on('scroll', function (e) {
                var $this = $(this);
                self.gridHeaderWrapper.scrollLeft($this.scrollLeft());
                self.scrollLeftPosition = $this.scrollLeft();

                if(null != self.lockedBodyContainer){
                    self.lockedBodyContainer.scrollTop($this.scrollTop())
                }

                if(self.infiniteLoading) {

                    var maxScroll = self.gridBodyWrapper[0].scrollHeight - self.gridBodyWrapper[0].clientHeight;

                    if ($this.scrollTop() + 20 > maxScroll) {

                        var nextpage = self.paginator.find('.next-page a');
                        var loadHref = nextpage.attr('href');

                        self.infiniteLoad(loadHref);
                    }


                }


            });

            this.gridBodyContainer.scrollLeft(this.scrollLeftPosition);
            this.gridHeaderContainer.scrollLeft(this.scrollLeftPosition);
        }

    };

    this.infiniteLoadingStarted = false;

    this.infiniteLoad = function(link){

        if(self.infiniteLoadingStarted){
            return;
        }
        self.infiniteLoadingStarted = true;

        self.startLoading();

        var quickSearchValue = "";
        if(this.quickSearch.length > 0){
            quickSearchValue = this.quickSearch.val();
        }

        $.ajax({
            'url': link,
            'method': 'GET'
        }).done(function (data) {
            LOG.log(data);

            if (data['result']) {

                /*
                if (data['data']['data']) {
                    var d = $(data['data']['data']);
                    self.gridData.replaceWith(d);
                }

                if (data['data']['paginator']) {
                    self.paginator.replaceWith(
                        $(data['data']['paginator'])
                    );
                }
                */


                if (data['data']['inner-container']) {
                    var inner = $(data['data']['inner-container']);

                    var pag = inner.find('.grid-paginator');

                    self.paginator.replaceWith(pag);
                    self.paginator = pag;



                    self.gridBodyWrapper.find('table').append(
                        inner.find('.grid-body tr')
                    );


                }

                /*
                self._bind();

                if (self.quickSearch.length > 0) {
                    self.quickSearch.val(quickSearchValue);
                }

                self._setupBodySize();
                self._setupScrollCorrect();
                self._setupResizeHandles();
                self._setupReorderHandles();
                self._setupGroups();

                self.highlightSelected();
                self._setupQuickSearch();

                self.gridBodyWrapper.scrollLeft(scrollLeft);
                self.gridBodyWrapper.scrollTop(scrollTop);
                */
            }

            self.infiniteLoadingStarted = false;
            self.stopLoading();
        });


    }


    this.startLoading = function () {
        this.loader.show();
    };

    this.stopLoading = function () {
        this.loader.hide();
    };

    this._setupScrollCorrect = function (refresh) {

        if (!this.isTableGrid) {
            return;
        }

        LOG.log("_setupScrollCorrect");

        var bodyWidth = this.gridBodyWrapper.find('table').width();

        LOG.log("   ", bodyWidth, this.grid.width());

        var w = 0;
        this.gridHeaderWrapper.find('tr.columns-row th').each(function () {
            w += parseInt($(this).css('width'));
        });

        if(refresh){
            this.gridHeaderWrapper.find('colgroup').find('[data-scroll-correct=1]').remove();
            this.gridHeaderWrapper.find('tr th.scroll-correct').remove();
            this.gridHeaderWrapper.find('table').css('width', w - SCROLL_CORRECT);
        }

        if (bodyWidth >= this.grid.width()) {

            if (this.gridHeaderWrapper.find('tr th.scroll-correct').length == 0) {

                this.gridHeaderWrapper.find('colgroup').append(
                    '<col data-fixed-width="1" style="width: ' + SCROLL_CORRECT + 'px;" data-scroll-correct="1"/>'
                );

                this.gridHeaderWrapper.find('tr').append(
                    "<th class='scroll-correct'></th>"
                );

                this.gridHeaderWrapper.find('table').css('width', w);
            }

        } else {

            if (this.gridHeaderWrapper.find('tr th.scroll-correct').length > 0) {

                this.gridHeaderWrapper.find('colgroup').find('[data-scroll-correct=1]').remove();
                this.gridHeaderWrapper.find('tr th.scroll-correct').remove();
                this.gridHeaderWrapper.find('table').css('width', w - SCROLL_CORRECT);

                self._setupResizeHandles();
            }

        }
    };

    this.headerDragging = false;

    this._setupReorderHandles = function () {

        if (!this.isTableGrid || !this._options.columnReorder) {
            return;
        }

        var $grid = $(this.grid);
        var $wrapper = $grid.find('.grid-header-wrapper');
        var $container = $grid.find('.grid-header-container');

        var i = 0;
        var offset = 0;
        $grid.find('.grid-header-wrapper .columns-row th > *').each(function () {
            var $col = $(this);
            $(this)
                .data('column', i)
                .data('leftOffset', offset);

            offset += $col.outerWidth();
            i++;

        });

        var $selected = null;
        var draggableClass = "handler-drag";

        $grid.find('.grid-header-wrapper .columns-row th > *').on("mousedown", function (e) {

            if (!$(this).closest('th').data('name')) {
                return;
            }

            var $this = $(this);
            var started = false;

            LOG.log("mouse down reorder", this);
            LOG.log("mouse down", $this.data('column'), $this);

            if(null != self.lockedHeaderTable){
                self.lockedHeaderTable.hide();
            }

            $selected = $(this).clone().css({
                'position': 'absolute',
                'left': $this.data('leftOffset'),
                'top': 0,
                'width': $this.outerWidth(),
                'height': $wrapper.outerHeight()
            }).addClass('reorder-clone');

            $selected.data('column', $this.data('column'));
            $selected.addClass(draggableClass);

            LOG.log("mousedown selected", $selected);

            var drg_w = $this.outerWidth(),
                pos_x = $this.offset().left + drg_w - e.pageX;

            var column = $this.data('column');

            var $column = $wrapper.find('colgroup col:nth-child(' + (column + 1) + ')');

            var $table = $wrapper.find('table');

            var $dataCol = $grid.find('.grid-body-wrapper colgroup col:nth-child(' + (column + 1) + ')');
            var $dataTable = $grid.find('.grid-body-wrapper table');

            var handlersAfter = $wrapper.find('.resize-handle:gt(' + (column) + ')');

            handlersAfter.each(function () {
                var $this = $(this);
                $this.data('startLeft', parseInt($this.css('left')));
            });

            var start_pagex = e.pageX;

            var start_x = e.pageX + pos_x;

            var resizeHandlers = new Array();

            LOG.log("reorder sta started", started);

            self.headerDragging = true;

            $(document).on("mousemove", function (e) {

                LOG.log("mousedown selected in move", started, $selected);

                var currentPosX = e.pageX + pos_x;

                LOG.log(currentPosX, $wrapper.scrollLeft());

                LOG.log("mousemove started", started, start_pagex, e.pageX);

                if (start_pagex == e.pageX) {
                    return;
                }

                if (!started && null != $selected) {
                    $selected.appendTo($container);
                    started = true;
                }

                if (resizeHandlers.length == 0) {

                    $grid.find('.grid-header-wrapper .resize-handle').each(function () {

                        var $handle = $(this);
                        var left = parseInt($handle.css('left')) + 2;

                        resizeHandlers.push({
                            'left': left,
                            'handle': $handle
                        });

                    });

                }

                var diff = currentPosX - start_x;

                $selected.offset({
                    //top: e.pageY + pos_y - drg_h,
                    left: currentPosX - drg_w
                });

                var cleft = $selected.position().left;

                if(cleft < 0){

                    // $selected.css({
                    //     left: currentPosX - drg_w + 10
                    // });
                    //
                    // cleft = $selected.position().left;

                    $wrapper.scrollLeft(
                        $wrapper.scrollLeft() + cleft
                    );

                    self.gridBodyWrapper.scrollLeft($wrapper.scrollLeft());

                }

                var rbound =  $wrapper.outerWidth();

                LOG.log("CCLEFT", cleft + drg_w, rbound);

                if(cleft + drg_w > rbound){

                    $wrapper.scrollLeft(
                        $wrapper.scrollLeft() + (cleft + drg_w - rbound)
                    );

                    self.gridBodyWrapper.scrollLeft($wrapper.scrollLeft());

                }



                cleft += $wrapper.scrollLeft();

                var current = null;

                for (var i in resizeHandlers) {

                    var h = resizeHandlers[i];
                    if (cleft < h['left']) {
                        current = h['handle'];
                    }

                    if (h['left'] > cleft) {
                        break;
                    }

                }

                if (null != current) {

                    if (!current.hasClass('reorder-highlight')) {
                        $grid.find('.grid-header-wrapper .resize-handle.reorder-highlight').removeClass('reorder-highlight');
                        current.addClass('reorder-highlight');
                    }

                }

            }).on("mouseup", function () {

                self.headerDragging = false;

                LOG.log("mouseup", started, $selected);

                $(this).off("mousemove"); // Unbind events from document

                if (!started) {

                }

                if ($selected !== null) {

                    var $handlePosition =
                        $grid.find('.grid-header-wrapper .resize-handle.reorder-highlight');

                    $handlePosition.removeClass('reorder-highlight');

                    if ($handlePosition) {

                        LOG.log($handlePosition);
                        var target = $handlePosition.data('column');

                        var source = $selected.data('column');
                        LOG.log('Move ', source, "after", target);

                        target++;
                        source++;

                        var $columnTarget = $wrapper.find('colgroup col:nth-child(' + (target) + ')');
                        var $columnSource = $wrapper.find('colgroup col:nth-child(' + (source) + ')');

                        var $thTarget = $wrapper.find('table .columns-row th:nth-child(' + (target) + ')');
                        var $thSource = $wrapper.find('table .columns-row th:nth-child(' + (source) + ')');

                        LOG.log("Move ", $thSource, "after", $thTarget);

                        $columnSource.insertAfter($columnTarget);
                        $thSource.insertAfter($thTarget);

                        var $bwrapper = $grid.find('.grid-body-wrapper');

                        $columnTarget = $bwrapper.find('colgroup col:nth-child(' + (target) + ')');
                        $columnSource = $bwrapper.find('colgroup col:nth-child(' + (source) + ')');

                        $columnSource.insertAfter($columnTarget);

                        var i = 0;
                        var offset = 0;
                        $grid.find('.grid-header-wrapper .columns-row th > *').each(function () {
                            var $col = $(this);
                            $(this)
                                .data('column', i)
                                .data('leftOffset', offset);

                            offset += $col.outerWidth();
                            i++;
                        });

                        $bwrapper.find('table tr').each(function () {
                            var $row = $(this);

                            var $t = $row.find('td:nth-child(' + (target) + ')');
                            var $s = $row.find('td:nth-child(' + (source) + ')');

                            $s.insertAfter($t);
                        });

                        self._setupResizeHandles();
                        self._setupGroups();

                        if(null != self.lockedHeaderTable){
                            self.lockedHeaderTable.remove();
                        }

                        self._lockColumns();

                        self._saveGridSettings();


                        $selected.remove();
                    }


                    //
                    //var column = $selected.data('column');
                    //
                    //
                    ////reset $selected position
                    //$selected.offset({
                    //	left: $column.offset().left + $column.outerWidth() - 3
                    //});
                    //
                    //$selected.removeClass(draggableClass);

                    $selected = null;
                } else{
                    if(null != self.lockedHeaderTable){
                        self.lockedHeaderTable.show();
                    }
                }
            });

            e.preventDefault(); // disable selection

        }).on("mouseup", function () {

            if ($selected !== null) {

                $selected.remove();

                $selected = null;
            }

        });

    };


    this._setupResizeHandles = function () {

        if (!this.isTableGrid || !this._options.columnReorder) {
            return;
        }

        LOG.log("HTGRID: _setupResizeHandles");

        var handle = '<div class="resize-handle"></div>';

        var $grid = $(this.grid);

        //clearing old ones
        $grid.find('.grid-header-wrapper .resize-handle').remove();

        var offset = -2;
        var i = 0;

        var $wrapper = $grid.find('.grid-header-wrapper');

        $grid.find('.grid-header-wrapper .columns-row th:not(.scroll-correct)').each(function () {

            var $col = $(this);

            offset += Math.floor($col.outerWidth());

            var $handle = $(handle)
                .css('left', (offset) + "px")
                .data('column', i)
                .appendTo($wrapper);

            if (!$col.data('name')) {
                $handle.addClass('disabled');
            }

            i++;
        });

        var $selected = null;

        var draggableClass = "handler-drag";

        var liveResizePreview = true;

        $grid.find('.grid-header-wrapper .resize-handle').on("mousedown", function (e) {

            if ($(this).is(".disabled")) {
                return;
            }

            var SCROLL = 0;
            if ($grid.find('scroll-correct').length > 0) {
                SCROLL = SCROLL_CORRECT;
            }

            $selected = $(this);
            $selected.addClass(draggableClass);

            var drg_w = $selected.outerWidth(),
                pos_x = $selected.offset().left + drg_w - e.pageX;

            var column = $selected.data('column');

            var $column = $wrapper.find('colgroup col:nth-child(' + (column + 1) + ')');

            var $table = $wrapper.find('table');

            var startWidth = parseInt($column.css('width'));
            var startTableWidth = parseInt($table.css('width'));

            var $dataCol = $grid.find('.grid-body-wrapper colgroup col:nth-child(' + (column + 1) + ')');
            var $dataTable = $grid.find('.grid-body-wrapper table');

            var handlersAfter = $wrapper.find('.resize-handle:gt(' + (column) + ')');

            handlersAfter.each(function () {
                var $this = $(this);
                $this.data('startLeft', parseInt($this.css('left')));
            });

            var start_x = e.pageX + pos_x;

            var $lockedHeaderCol = null;
            if(null != self.lockedHeaderTable){
                $lockedHeaderCol = self.lockedHeaderTable.find('colgroup col:nth-child(' + (column + 1) + ')');
            }

            var $lockedBodyCol = null;
            if(null != self.lockedBodyContainer){
                $lockedBodyCol = self.lockedBodyContainer.find('table colgroup col:nth-child(' + (column + 1) + ')');
            }

            self.headerDragging = true;

            var colWidth;

            var tableWidth;

            if ($wrapper.find('.scroll-correct').length > 0) {
                SCROLL = 17;
            } else {
                SCROLL = 0;
            }

            $(document).on("mousemove", function (e) {

                var currentPosX = e.pageX + pos_x;
                var diff = currentPosX - start_x;

                tableWidth = startTableWidth + diff;

                colWidth = startWidth + diff;

                if (colWidth < 0) {
                    colWidth = 0;
                    diff = -1 * startWidth;
                }

                $table.css('width', tableWidth + "px");



                $column.css('width', colWidth + "px");

                if(liveResizePreview) {
                    $dataTable.css('width', tableWidth - SCROLL + "px");
                    $dataCol.css('width', colWidth + "px");
                }

                if(null != $lockedHeaderCol){
                    $lockedHeaderCol.css('width', colWidth + "px");
                }

                if(null != $lockedBodyCol){
                    $lockedBodyCol.css('width', colWidth + "px");
                }

                $selected.offset({
                    //top: e.pageY + pos_y - drg_h,
                    left: currentPosX - drg_w
                });

                handlersAfter.each(function () {
                    var $this = $(this);
                    $this.css({
                        'left': ($this.data('startLeft') + diff) + 'px'
                    });
                });


            }).on("mouseup", function () {

                $dataCol.css('width', colWidth + "px");

                if ($wrapper.find('.scroll-correct').length > 0) {
                    SCROLL = 17;
                } else {
                    SCROLL = 0;
                }
                $dataTable.css('width', tableWidth - SCROLL + "px");

                self.headerDragging = false;

                $(this).off("mousemove"); // Unbind events from document

                if ($selected !== null) {

                    var column = $selected.data('column');
                    var $column = $wrapper.find('tr.columns-row th:nth-child(' + (column + 1) + ')');

                    //reset $selected position
                    $selected.offset({
                        left: $column.offset().left + $column.outerWidth() - 3
                    });

                    $selected.removeClass(draggableClass);
                    $selected = null;

                    self._setupScrollCorrect();

                    self._saveGridSettings();
                }
            });
            e.preventDefault(); // disable selection

        }).on("mouseup", function () {

            if ($selected !== null) {

                var column = $selected.data('column');
                var $column = $wrapper.find('tr.columns-row th:nth-child(' + (column + 1) + ')');

                //reset $selected position
                //chrome moves 1px more than firefox!
                //chrome should be -2
                $selected.offset({
                    left: $column.offset().left + $column.outerWidth() - 3
                });

            }

            $selected.removeClass(draggableClass);
            $selected = null;


            self._setupScrollCorrect();
            self._saveGridSettings();
        });

    };


    this._setupGroups = function () {

        if (!this.isTableGrid) {
            return;
        }

        LOG.log("HTGRID: _setupGroups");

        var $grid = $(this.grid);
        var $container = $grid.find('.grid-header-container');

        if (!$container.hasClass('with-groups')) {
            return;
        }

        $grid.find('.grid-header-wrapper tr.groups-row').remove();

        var $wrapper = $grid.find('.grid-header-wrapper table thead');

        var $groups = $('<tr class="groups-row"></tr>');

        var i = 0;
        var offset = 0;

        var prevGroup = null;
        var prevSpan = 1;

        $grid.find('.grid-header-wrapper th').each(function () {

            var $th = $(this);
            var width = $th.outerWidth();

            var group = $th.data('group');

            if (group) {

                if (null != prevGroup) {

                    if (prevGroup.text() == group) {
                        prevSpan++;
                        prevGroup.attr('colspan', prevSpan);
                    } else {
                        prevSpan = 1;
                        var g = $('<th>' + group + '</th>');
                        $groups.append(g);
                        prevGroup = g;
                    }

                } else {
                    prevSpan = 1;
                    var g = $('<th>' + group + '</th>');
                    $groups.append(g);
                    prevGroup = g;
                }

            } else {
                prevSpan = 1;
                prevGroup = null;
                $groups.append('<th class="empty"></th>');
            }

            offset += width;
            i++;
        });

        $groups.prependTo($wrapper);

    };

    this.filter = function (filters) {
        LOG.log("filter", filters);

        if(this.quickSearch.length > 0){

            if(this.quickSearch.val() != ''){
                filters.push(
                    this.quickSearch.attr('name') + "~LIKE~" + encodeURIComponent(this.quickSearch.val())
                );

                this.quickSearch.addClass('active');
            }else{
                this.quickSearch.removeClass('active');
            }

        }

        //czyscimy zaznaczone pola
        this.selected = new Array();

        var url = this.gridData.data('current-order');

        var name = '&' + this.id() + '-filter[]=';

        $.each(filters, function (k, v) {
            url += name + v;
        });

        if (url.charAt(0) == '&') {
            url = '?' + url;
        }

        url = encodeURI(url);

        LOG.log(url);
        LOG.log(filters);

        this.gotoHref(url);

    };

    this.gotoHref = function (link, scrollTop, scrollLeft) {

        LOG.log("GO HREF", link, scrollTop);

        if (scrollTop == undefined) {
            scrollTop = 0;
        }

        if (scrollLeft == undefined) {
            scrollLeft = 0;
        }

        LOG.log('gotoHref: ' + link);
        LOG.log('  top position: ' + scrollTop);

        //window.location.hash = link;

        var $this = $(this);

        self.startLoading();

        var quickSearchValue = "";

        if(this.quickSearch.length > 0){
            quickSearchValue = this.quickSearch.val();
        }

        $.ajax({
            'url': link,
            'method': 'GET'
        }).done(function (data) {
            LOG.log(data);

            if (data['data']['data']) {
                var d = $(data['data']['data']);
                self.gridData.replaceWith(d);
            }

            if (data['data']['paginator']) {
                self.paginator.replaceWith(
                    $(data['data']['paginator'])
                );
            }

            if (data['data']['inner-container']) {
                self.innerContainer.replaceWith(
                    $(data['data']['inner-container'])
                );
            }

            self._bind();

            if(self.quickSearch.length > 0){
                self.quickSearch.val(quickSearchValue);
                if(quickSearchValue != ''){
                    self.quickSearch.addClass('active');
                }
            }

            self._setupBodySize();
            self._setupScrollCorrect();
            self._setupResizeHandles();
            self._setupReorderHandles();
            self._setupGroups();
            self._updateLock();

            self.highlightSelected();
            self._setupQuickSearch();

            self.gridBodyWrapper.scrollLeft(scrollLeft);
            self.gridBodyWrapper.scrollTop(scrollTop);

            if(isIE11){

                setTimeout(function () {

                    LOG.log('Timeot ie correct', self.gridHeaderWrapper.find('tr th.scroll-correct'));

                    var cc = self.gridHeaderWrapper.find('tr th.scroll-correct');

                    if(cc.length > 0){

                        var bodyWidth = self.gridBodyWrapper.find('table').width();
                        self.gridHeaderWrapper.find('table').css('width', bodyWidth + SCROLL_CORRECT);
                    }

                }, 300);

            }

            self.stopLoading();

            if(self.contentReloadedCallback){
                self.contentReloadedCallback(data);
            }
        });

    };

    this.clickLink = function (event) {
        LOG.log('a click');
        event.preventDefault();

        var link = $(this).attr('href');

        self.gotoHref(link);
    };

    this.clickLinkWithPos = function (event) {
        LOG.log('a click');
        event.preventDefault();

        var link = $(this).attr('href');

        var left = self.gridBodyWrapper.scrollLeft();
        //var top = self.gridBodyWrapper.scrollTop();

        self.gotoHref(link, 0, left);
    };

    this.refresh = function () {

        var left = this.gridBodyWrapper.scrollLeft();
        var top = this.gridBodyWrapper.scrollTop();

        this.gotoHref(
            this.paginator.data('current-url'),
            top, left
        );


    };

    this.grid.on('click', 'a.order-by-link', this.clickLinkWithPos);
    this.grid.on('click', '.grid-paginator a', this.clickLinkWithPos);
    this.grid.on('click', '.grid-view-switch a', this.clickLink);

    $(window).on('resize', function () {
        self._setupBodySize();
        self._setupScrollCorrect();
    });

    this._setupBodySize();

    self._setupScrollCorrect();

    self._setupResizeHandles();
    self._setupReorderHandles();

    self._setupGroups();

    self._setupSelectable();
    self._setupQuickSearch();

    self._lockColumns();

    if(isIE11){

        setTimeout(function () {

            LOG.log('Timeot ie correct', self.gridHeaderWrapper.find('tr th.scroll-correct'));

            var cc = self.gridHeaderWrapper.find('tr th.scroll-correct');

            if(cc.length > 0){

                var bodyWidth = self.gridBodyWrapper.find('table').width();
                self.gridHeaderWrapper.find('table').css('width', bodyWidth + SCROLL_CORRECT);
            }

        }, 300);

    }

    this.gridFilter = this.grid.find('.grid-filter');

    this.htGridFilterComponent = null;

    if (this.gridFilter.length > 0) {

        // this.grid.find('.toggle').click(function () {
        //     self.gridFilter.toggleClass('active');
        // });

        //TODO: rewrite

        this.htGridFilterComponent = new HtGridFilter(this.gridFilter, {
            grid: this
        });

        //htc.initComponent(this.gridFilter[0], 'gridFilter', {
            //'grid': this
        //});
    }

    LOG.log("HAASSH", window.location.hash);

    if(window.location.hash) {
        // Fragment exists
        var hash = window.location.hash.replace('#', '');

        var item = this.gridBodyWrapper.find('.item[data-id=' + hash +']');


        LOG.log("IIIIIIIIIIIIIII TEM", item);

        if(item.length > 0){
            item.trigger('mouseup');
        }

    }

};